export const STORAGE_KEYS = {
  REMEMBERED_USERNAME: 'rememberedUsername',
  SHOW_DASHBOARD_TOAST: 'showDashboardToast'
} as const;

export const AUTH_METHODS = {
  FINGERPRINT: 'fingerprint',
  PIN: 'pin',
  SECURITY_KEY: 'security-key'
} as const;

export const ERROR_KEYWORDS = {
  EMAIL_VERIFICATION_REQUIRED: 'email verification required',
  GRACE_PERIOD_EXPIRED: 'gracePeriodExpired',
  INVALID_CREDENTIAL: 'invalid-credential',
  WRONG_PASSWORD: 'wrong-password',
  USER_NOT_FOUND: 'user-not-found',
  EMAIL_ALREADY_IN_USE: 'email-already-in-use',
  WEAK_PASSWORD: 'weak-password',
  INVALID_EMAIL: 'invalid-email'
} as const;

export const DEVICE_IDENTIFIERS = {
  IPHONE: 'iphone',
  IPAD: 'ipad',
  IPHONE_X: 'iphone x',
  IPHONE_1: 'iphone 1',
  IPAD_PRO: 'ipad pro',
  PRO: 'pro',
  BOOK: 'book',
  LAPTOP: 'laptop'
} as const;

export const VALIDATION = {
  MIN_PASSWORD_LENGTH: 6
} as const;
